/**
 * Catalog image lookup — templateKey → static config only (no path building or slot scanning).
 */
import {
  BY_DIFFICULTIES_GROUP_IMAGE_CONFIG_V1,
  BY_DIFFICULTIES_TEST_IMAGE_CONFIG_V1,
} from './catalogImageConfigByDifficulties.v1';
import {
  BY_TOPICS_CROSS_BAND_IMAGE_CONFIG_V1,
  BY_TOPICS_GROUP_IMAGE_CONFIG_V1,
  BY_TOPICS_TEST_IMAGE_CONFIG_V1,
  type CatalogStaticImageRef,
} from './catalogImageConfigByTopics.v1';

export type CatalogImageRef = CatalogStaticImageRef;

/** Legacy seeder / population ids without `.slot.N` (maps to slot 1 in static config). */
const LEGACY_BY_DIFFICULTIES_TEST_KEY =
  /^difficulty\.(soft|medium|hard)\.topic\.[a-z0-9-]+$/i;

export function catalogImageForByDifficultiesTemplateKey(
  templateKey: string
): CatalogImageRef | undefined {
  const key = templateKey.trim();
  if (!key) return undefined;
  return (
    BY_DIFFICULTIES_GROUP_IMAGE_CONFIG_V1[key] ?? BY_DIFFICULTIES_TEST_IMAGE_CONFIG_V1[key]
  );
}

export function catalogImageForByTopicsTemplateKey(
  templateKey: string
): CatalogImageRef | undefined {
  const key = templateKey.trim();
  if (!key) return undefined;
  return (
    BY_TOPICS_GROUP_IMAGE_CONFIG_V1[key] ??
    BY_TOPICS_TEST_IMAGE_CONFIG_V1[key] ??
    BY_TOPICS_CROSS_BAND_IMAGE_CONFIG_V1[key]
  );
}

/** Resolve image by Firestore / config templateKey (routes to BY_TOPICS or BY_DIFFICULTIES map). */
export function catalogImageForTemplateKey(templateKey: string): CatalogImageRef | undefined {
  const key = String(templateKey || '').trim();
  if (!key) return undefined;
  if (key.startsWith('topic.')) {
    return catalogImageForByTopicsTemplateKey(key);
  }
  if (key.startsWith('difficulty.')) {
    const image = catalogImageForByDifficultiesTemplateKey(key);
    if (image) return image;
    if (LEGACY_BY_DIFFICULTIES_TEST_KEY.test(key)) {
      return catalogImageForByDifficultiesTemplateKey(`${key}.slot.1`);
    }
    return undefined;
  }
  return undefined;
}
